import React from "react";
import {
  Box,
  Grid,
  Typography,
  Link,
  useTheme,
  useMediaQuery,
  Divider,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import background from "../../Assets/Background/background.png";
import "./Contact.css";
const ContactUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
        }}
        className="ImageContainer"
      >
        {/* Background Image */}
        <img
          src={background}
          alt="Yoga Pose"
          style={{
            objectFit: "cover",
          }}
          className="image"
        />

        {/* Text Content */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: { xs: "5%", sm: "8%", md: "10%" },
            transform: "translateY(-50%)",
            color: "#2e2e2e", // dark text (you can change to white if needed)
            zIndex: 1,
            maxWidth: { xs: "90%", sm: "60%", md: "40%" },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
              color: "#555",
              width: { xs: "90%", sm: "80%", md: "70%" },
            }}
            className="textonimage"
          >
            <em style={{ color: "#333", fontStyle: "italic" }}>
              “When you listen to yourself, everything comes naturally. It comes
              from inside, like a kind of will to do something. Try to be
              sensitive. That is yoga.”
            </em>
          </Typography>

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}></Box>
        </Box>
      </Box>
      <Box sx={{ pt: 4, px: 2, mb: 4 }} className="contactContainer">
        {/* Title */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            pb: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#106870",
              position: "relative",
              display: "inline-block",
              "&::after": {
                content: '""',
                position: "absolute",
                left: "50%",
                bottom: -8,
                transform: "translateX(-50%)",
                width: "150px",
                height: "3px",
                backgroundColor: "#F1A293",
                borderRadius: "2px",
              },
            }}
          >
            Contact Us
          </Typography>
        </Box>

        {/* Layout: Form + Divider + Address */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: "flex-start",
            gap: 4,
          }}
        >
          {/* Left: Contact Form */}
          <Box
            component="form"
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              maxWidth: "400px",
              width: "100%",
              alignSelf: "center",
            }}
          >
            <input
              type="text"
              placeholder="First Name"
              style={{
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                backgroundColor: "#fff8f5",
              }}
            />
            <input
              type="text"
              placeholder="Last Name"
              style={{
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                backgroundColor: "#fff8f5",
              }}
            />
            <input
              type="email"
              placeholder="Email"
              style={{
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                backgroundColor: "#fff8f5",
              }}
            />
            <button
              type="submit"
              style={{
                padding: "10px",
                borderRadius: "4px",
                backgroundColor: "#106870",
                color: "#fff",
                fontWeight: "bold",
                border: "none",
                cursor: "pointer",
              }}
            >
              Send
            </button>
          </Box>

          {/* Vertical Divider */}
          {!isMobile && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "#F1A293", mx: 2 }}
            />
          )}

          {/* Right: Address Info with Icons */}
          <Box
            sx={{
              flex: 1,
              maxWidth: "500px",
              width: "100%",
              ml: { xs: 0, md: 3 },
              mt: { xs: 4, md: 0 },
              backgroundColor: "#f1f1f1",
              padding: "12px",
              maxWidth: "380px", // This maxWidth might conflict with the first one. Choose the one you prefer.
              alignSelf: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <EmailIcon sx={{ mr: 2 }} />
              <Typography>Ask@swatsan.com</Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <PhoneIcon sx={{ mr: 2 }} />
              <Typography>+91 9356461900</Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <WhatsAppIcon sx={{ mr: 2, color: "#25D366" }} />
              <Typography>+91 9356461900 (Chat with Us)</Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
              <LocationCityIcon sx={{ mr: 2, mt: 0.5 }} />
              <Typography>
                SR NO. 15/11/1, Waraje Naka, Canal Road
                <br />
                Hingane Budruk, Pune,
                <br />
                Maharashtra 411058
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;
